import { render, staticRenderFns } from "./IconPeopleAdd.vue?vue&type=template&id=80d4db88&"
import script from "./IconPeopleAdd.vue?vue&type=script&lang=js&"
export * from "./IconPeopleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80d4db88')) {
      api.createRecord('80d4db88', component.options)
    } else {
      api.reload('80d4db88', component.options)
    }
    module.hot.accept("./IconPeopleAdd.vue?vue&type=template&id=80d4db88&", function () {
      api.rerender('80d4db88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconPeopleAdd.vue"
export default component.exports